import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { router } from './router'
import { hydrateAuthFromStorage } from './store/authStore'
import { queryClient } from './api/queryClient'
import './index.css'

// Hydrate auth from localStorage BEFORE the router renders, so
// ProtectedRoute sees the correct isAuthenticated state on first paint.
hydrateAuthFromStorage()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
)
